import { TActionButtonV2 } from './actionButtonV2';
import { TActionButtonV3 } from './actionButtonV3';
import { TTypeChatbot, IChatbotMessageSchema } from './chatbot';
import { TMessageBubble } from './messageBubble';
import { TMessageFiles } from './messageFiles';
import { IMessageInChatList } from '../repositories/chats/entities/chat/MessageInChatList';
import { IOfferForClient1 } from '../repositories/chats/entities/for_client/OfferForClient1';
import {
  TType,
  TStatus,
  IMessageListItemV2,
} from '../repositories/chats/entities/message_list_item_v2/MessageListItemV2';
import { IErrorResponseSchema } from '../repositories/chats/entities/schemas/ErrorResponseSchema';

import type { IMessageAssumptions1 } from '../repositories/chats/entities/check_message/MessageAssumptions1';

type TMessageType = TType | TTypeChatbot;

type TMessageSchema = Omit<IMessageListItemV2, 'type' | 'status'> &
  Omit<IChatbotMessageSchema, 'fromChatBot' | 'canBeDeleted' | 'fromCrm' | 'type' | 'status'> & {
    fromChatBot?: boolean;
    rowVersionV2?: string;
    canBeDeleted?: boolean;
    fromCrm?: boolean;
    type: TMessageType;
    status: TStatus;
    unread: boolean;
  };

enum EOutcomingStatus {
  Pending = 'pending',
  Failed = 'failed',
  Fulfilled = 'fulfilled',
  Read = 'read',
}
// TODO - перейти на один тип (в циан-помошнике сейчас используется number)
type TRowVersion = number | string;

type TOutcomingStatus = `${EOutcomingStatus}`;

type TBaseMessage = {
  created: number;
  message: string;
  htmlText?: string | null;
  userId: number;
  actionButtons?: TActionButtonV2[] | null;
  actionButtonsV3?: TActionButtonV3[] | null;
  files?: TMessageFiles | null;
  isRead?: boolean;
  assumptions?: IMessageAssumptions1 | null;
  offers?: IOfferForClient1[];
  bubbles?: TMessageBubble[] | null;
  type?: TMessageType;
  isOutcoming: boolean;
  rowVersion?: TRowVersion;
  images?: string[] | null;
  fromCrm?: boolean;
  fromChatBot?: boolean;
  communicationId?: string | null;
  animation?: boolean;
};

type TIncomingMessage = TBaseMessage & {
  isRead: boolean;
};

type TOutcomingMessage = TBaseMessage & {
  status: TOutcomingStatus;
};

type TMessage = TIncomingMessage | TOutcomingMessage;

export {
  type TTypeChatbot,
  type TType as TMessageType,
  type TStatus as TStatusMessage,
  IMessageAssumptions1,
  EOutcomingStatus,
};
export type {
  IMessageListItemV2 as TMessageListItemV2,
  IErrorResponseSchema as TMessagesResponseError,
  TMessage,
  TMessageSchema,
  TOutcomingStatus,
  IMessageInChatList as TLastMessageInChatList,
  TRowVersion,
};
